/* L'OREMONT PARIS — V2 Motion & Commerce
   Nur transform/opacity/clip-path · Easing 0.16,1,0.3,1 · Reduced-Motion-sicher */

const staticMode = document.documentElement.classList.contains('is-static');
const reducedMq = window.matchMedia('(prefers-reduced-motion: reduce)');
let prefersReduced = staticMode || reducedMq.matches;
const pointerFine = window.matchMedia('(pointer: fine)').matches;
const saveData = navigator.connection && navigator.connection.saveData;
const EASE = 'expo.out';

/* ---------- Failsafe: Seite darf NIE hinterm Preloader hängen ---------- */
let initDone = false;
function killPreloader() {
  const pre = document.getElementById('preloader');
  if (pre) pre.style.display = 'none';
  document.querySelectorAll('.nav, .reveal, .reveal-img, .lead-inner, .hero h1 .word, .hero-product, .hero-glow, .hero-rake')
    .forEach((el) => { el.style.opacity = ''; el.style.transform = ''; el.style.clipPath = ''; el.style.filter = ''; });
  document.documentElement.classList.add('is-static');
}
// Nur während des Preloaders/Init aktiv: ein späterer Fehler (Apps, Cookie-Banner)
// darf die längst geladene Seite nicht mehr auf is-static zurückschalten.
function onEarlyError() {
  if (initDone) return;
  killPreloader();
}
function markInitDone() {
  initDone = true;
  window.removeEventListener('error', onEarlyError);
}
window.addEventListener('error', onEarlyError);
const failsafe = setTimeout(() => { killPreloader(); markInitDone(); }, 4000);

if (!staticMode && window.gsap) initSite();
else if (staticMode) { clearTimeout(failsafe); markInitDone(); document.getElementById('stage-num').textContent = '01'; }
else { killPreloader(); markInitDone(); } // GSAP fehlt → sofort statisch zeigen, nicht 4 s schwarz

function initSite() {
  clearTimeout(failsafe);
  gsap.registerPlugin(ScrollTrigger);

  const video = document.getElementById('hero-video');

  /* ---------- Hero-Video-Disziplin ---------- */
  (function heroVideo() {
    if (!video) return;
    if (saveData) { video.remove(); return; }
    if (prefersReduced) { video.pause(); return; }
    const tryPlay = () => video.play().catch(() => {});
    tryPlay();
    new IntersectionObserver(([e]) => {
      if (prefersReduced) return;
      e.isIntersecting ? tryPlay() : video.pause();
    }).observe(video);
  })();

  /* ---------- Intro: L'OREMONT zeichnet sich ---------- */
  (function intro() {
    const pre = document.getElementById('preloader');
    if (prefersReduced) {
      pre.style.display = 'none';
      gsap.set('.reveal, .hero h1 .word, .hero-product, .hero-eyebrow, .hero-sub, .hero-price-line, .hero-cta', { clearProps: 'opacity,transform' });
      markInitDone();
      return;
    }
    gsap.set('.hero h1 .word', { yPercent: 118 });
    gsap.set(['.hero-eyebrow', '.hero-sub', '.hero-price-line', '.hero-cta'], { opacity: 0, y: 26 });
    /* WICHTIG: hero-product/glow/rake werden NICHT eager versteckt — der versteckte
       Zustand entsteht erst im fromTo der Timeline. Stirbt die Timeline (Fehler,
       Third-Party-Script), bleibt das Wallet beim CSS-Default: sichtbar. */
    gsap.set('.hero-glow', { xPercent: -50, yPercent: -50 });
    gsap.set('.nav', { opacity: 0, y: -16 });

    function heroIdle() {
      if (prefersReduced) return;
      gsap.to('.hero-product', { yPercent: -3.2, duration: 3.4, ease: 'sine.inOut', yoyo: true, repeat: -1 });
      gsap.to('.hero-glow', { opacity: .82, scale: 1.06, duration: 2.8, ease: 'sine.inOut', yoyo: true, repeat: -1 });
    }

    const tl = gsap.timeline({ defaults: { ease: EASE }, onComplete: markInitDone });
    tl.fromTo('.pre-word', { opacity: 0, letterSpacing: '.3em' }, { opacity: 1, letterSpacing: '.14em', duration: .9, ease: 'expo.inOut' })
      .to('.pre-line line', { strokeDashoffset: 0, duration: .8, ease: 'expo.inOut' }, '-=.45')
      .fromTo('.pre-paris', { opacity: 0 }, { opacity: 1, duration: .45 }, '-=.5')
      .to(pre, { yPercent: -100, duration: .65, ease: 'expo.inOut', delay: .15 })
      .set(pre, { display: 'none' })
      .to('.hero h1 .word', { yPercent: 0, duration: 1.1, stagger: .12 }, '-=.3')
      .to('.nav', { opacity: 1, y: 0, duration: .8 }, '-=.9')
      .to('.hero-eyebrow', { opacity: 1, y: 0, duration: .7 }, '-=.85')
      .to('.hero-sub', { opacity: 1, y: 0, duration: .7 }, '-=.6')
      .to('.hero-price-line', { opacity: 1, y: 0, duration: .7 }, '-=.55')
      .to('.hero-cta', { opacity: 1, y: 0, duration: .7 }, '-=.5')
      .fromTo('.hero-glow', { opacity: 0, scale: .6 }, { opacity: 1, scale: 1, duration: 1.5, ease: 'sine.out', immediateRender: false }, '-=1.05')
      .fromTo('.hero-product',
        { opacity: 0, yPercent: 34, scale: .8, rotationX: 26, rotationY: -10, filter: 'blur(16px)' },
        { opacity: 1, yPercent: 0, scale: 1, rotationX: 0, rotationY: 0, filter: 'blur(0px)', duration: 1.7, ease: 'expo.out', immediateRender: false }, '-=1.35')
      .fromTo('.hero-rake--key', { opacity: 0 }, { opacity: .82, duration: .9, ease: 'sine.out', immediateRender: false }, '-=.35')
      .fromTo('.hero-rake--spec', { opacity: 0 }, { opacity: .66, duration: .9, ease: 'sine.out', immediateRender: false }, '<')
      .add(heroIdle, '-=.2');

    /* Hard-Failsafe: Das Wallet darf NIE unsichtbar hängen bleiben — egal was
       mit GSAP/der Timeline passiert. Nach 6 s wird der Endzustand erzwungen. */
    setTimeout(() => {
      const prod = document.querySelector('.hero-product');
      if (!prod) return;
      if (parseFloat(getComputedStyle(prod).opacity) < .9) {
        document.querySelectorAll('.hero-product, .hero-glow, .hero-rake').forEach((el) => {
          el.style.opacity = ''; el.style.transform = ''; el.style.filter = '';
        });
      }
    }, 6000);
  })();

  /* ---------- Hero-Parallax (3 Geschwindigkeiten + Video) ---------- */
  if (!prefersReduced) {
    gsap.timeline({
      scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true },
    })
      .to('.hero-video', { scale: 1.08, opacity: .55, ease: 'none' }, 0)
      .to('.hero h1', { y: -40, ease: 'none' }, 0)
      .to('.hero-sub, .hero-price-line, .hero-cta', { y: -70, ease: 'none' }, 0)
      .to('.hero-stage', { y: -110, ease: 'none' }, 0)
      .to('.hero-scroll', { opacity: 0, ease: 'none' }, 0);
  }

  /* ---------- Hero: 3D-Tilt + Specular Light-Rake (Desktop) ----------
     Cursor steuert Neigung UND ein an die Leder-Silhouette maskiertes Streiflicht
     (adaptiert: Frontend Masters „CSS Spotlight" + Codrops „Dynamic CSS Masks"). */
  if (pointerFine && !prefersReduced) {
    const tilt = document.querySelector('.hero-tilt');
    const stage = document.querySelector('.hero-stage');
    const glow = document.querySelector('.hero-glow');
    if (tilt && stage) {
      const rx = gsap.quickTo(tilt, 'rotationX', { duration: .7, ease: EASE });
      const ry = gsap.quickTo(tilt, 'rotationY', { duration: .7, ease: EASE });
      const gx = glow ? gsap.quickTo(glow, 'xPercent', { duration: .9, ease: EASE }) : null;
      // Light-Rake: eigener geglätteter rAF-Lerp auf die CSS-Custom-Props (mit Einheit)
      const target = { lx: 50, ly: 36, sx: 50, sa: 118 }, cur = { ...target };
      let rafOn = false;
      const rakeTick = () => {
        let moving = false;
        for (const k in target) { cur[k] += (target[k] - cur[k]) * .12; if (Math.abs(target[k] - cur[k]) > .05) moving = true; }
        stage.style.setProperty('--lx', cur.lx.toFixed(1) + '%');
        stage.style.setProperty('--ly', cur.ly.toFixed(1) + '%');
        stage.style.setProperty('--sheenX', cur.sx.toFixed(1) + '%');
        stage.style.setProperty('--sheenA', cur.sa.toFixed(1) + 'deg');
        if (moving) requestAnimationFrame(rakeTick); else rafOn = false;
      };
      const rake = () => { if (!rafOn) { rafOn = true; requestAnimationFrame(rakeTick); } };
      window.addEventListener('pointermove', (e) => {
        const cx = e.clientX / window.innerWidth - .5, cy = e.clientY / window.innerHeight - .5;
        rx(gsap.utils.clamp(-6, 6, -cy * 8));
        ry(gsap.utils.clamp(-7, 7, cx * 9));
        if (gx) gx(-50 + gsap.utils.clamp(-10, 10, cx * 16));
        target.lx = 50 + cx * 58; target.ly = 36 + cy * 50;   // Keylight folgt dem Cursor
        target.sx = 50 + cx * 26; target.sa = 118 - cx * 66;  // Specular-Streif wandert + kippt
        rake();
      }, { passive: true });
      const heroEl = tilt.closest('.hero');
      if (heroEl) heroEl.addEventListener('pointerleave', () => { target.lx = 50; target.ly = 36; target.sx = 50; target.sa = 118; rake(); });
    }
  }

  /* ---------- Farbauswahl: recolort das 3D-Wallet ---------- */
  (function walletColors() {
    const swatches = document.querySelectorAll('.hero-swatches .swatch');
    const leatherEl = document.getElementById('hero-leather');
    if (!swatches.length) return;
    swatches.forEach((sw) => sw.addEventListener('click', () => {
      swatches.forEach((s) => { s.classList.remove('is-active'); s.setAttribute('aria-checked', 'false'); });
      sw.classList.add('is-active'); sw.setAttribute('aria-checked', 'true');
      if (typeof window.loremontSetLeather === 'function') window.loremontSetLeather(sw.dataset.color);
      if (leatherEl && sw.dataset.name) leatherEl.textContent = `${sw.dataset.name}-Kroko`;
      if (!prefersReduced) gsap.fromTo(sw, { scale: .8 }, { scale: 1, duration: .4, ease: 'back.out(2)' });
    }));
    // Pfeiltasten-Navigation (radiogroup-Semantik)
    const arr = [...swatches];
    swatches.forEach((sw, i) => sw.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      const next = arr[(i + (e.key === 'ArrowRight' ? 1 : arr.length - 1)) % arr.length];
      next.focus(); next.click();
    }));
  })();

  /* ---------- Nav-Zustand ---------- */
  ScrollTrigger.create({
    start: 60,
    onToggle: (self) => document.getElementById('nav').classList.toggle('is-scrolled', self.isActive),
  });

  /* ---------- Burger-Menü ---------- */
  (function burger() {
    const toggle = document.getElementById('nav-toggle');
    const panel = document.getElementById('nav-panel');
    const links = panel.querySelectorAll('a');
    let open = false;

    function setOpen(next) {
      open = next;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
      panel.hidden = false;
      requestAnimationFrame(() => panel.classList.toggle('is-open', open));
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        if (!prefersReduced) gsap.fromTo(links, { opacity: 0, y: 18 }, { opacity: 1, y: 0, duration: .5, stagger: .05, ease: EASE, delay: .1 });
        links[0].focus();
      } else {
        setTimeout(() => { panel.hidden = true; }, 500);
        toggle.focus();
      }
    }
    toggle.addEventListener('click', () => setOpen(!open));
    links.forEach((a) => a.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => {
      if (!open) return;
      if (e.key === 'Escape') setOpen(false);
      if (e.key === 'Tab') {
        const f = [toggle, ...links];
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      }
    });
  })();

  /* ---------- Marken-Übergang „L'Oremont Paris" beim Menü-Klick ---------- */
  (function pageWipe() {
    const wipe = document.getElementById('page-wipe');
    if (!wipe) return;
    const lockup = wipe.querySelector('.pre-lockup');
    const lines = wipe.querySelectorAll('.pre-line line');
    const anchors = document.querySelectorAll('.nav-links a[href^="#"], .nav-panel a[href^="#"]');
    let busy = false;
    anchors.forEach((a) => a.addEventListener('click', (e) => {
      const id = a.getAttribute('href');
      if (!id || id === '#') return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      if (prefersReduced) { target.scrollIntoView(); history.replaceState(null, '', id); return; }
      if (busy) return; busy = true;
      const go = () => { target.scrollIntoView({ block: 'start' }); history.replaceState(null, '', id); };
      gsap.timeline({ onComplete: () => { busy = false; } })
        .set(wipe, { visibility: 'visible', clipPath: 'inset(0 0 100% 0)' })
        .set(lines, { strokeDashoffset: 1 })
        .set(lockup, { opacity: 0, y: 8 })
        .to(wipe, { clipPath: 'inset(0 0 0% 0)', duration: .5, ease: 'expo.inOut' })
        .to(lockup, { opacity: 1, y: 0, duration: .3, ease: EASE }, '-=.22')
        .to(lines, { strokeDashoffset: 0, duration: .35, ease: 'expo.inOut' }, '-=.16')
        .add(go, '+=.02')
        .to(lockup, { opacity: 0, duration: .25, ease: EASE }, '+=.12')
        .to(wipe, { clipPath: 'inset(100% 0 0 0)', duration: .5, ease: 'expo.inOut' }, '-=.04')
        .set(wipe, { visibility: 'hidden', clipPath: 'inset(0 0 100% 0)' });
    }));
  })();

  /* ---------- Marquee: seamless (neu vermessen nach Font-Swap, genug Kopien) ---------- */
  (function marquee() {
    if (prefersReduced) return;
    const track = document.getElementById('marquee-track');
    if (!track) return;
    const original = track.innerHTML;   // 2 identische Grundeinheiten wie im Markup
    let unit = 0, wrap = (v) => v, x = 0, vel = 0, lastY = window.scrollY;

    function build() {
      track.innerHTML = original;
      const base = track.scrollWidth / 2 || 1;                         // Breite EINER Einheit
      const need = Math.max(2, Math.ceil((window.innerWidth * 3) / base)); // > 3× Viewport → keine Lücke
      let html = ''; for (let i = 0; i < need; i++) html += original;
      track.innerHTML = html;
      unit = track.scrollWidth / (need * 2);                           // exakt EINE Einheit
      wrap = gsap.utils.wrap(-unit, 0);
      x = wrap(x);
    }
    build();
    window.addEventListener('scroll', () => { vel += (window.scrollY - lastY) * .06; lastY = window.scrollY; }, { passive: true });
    let rt = null;
    window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(build, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);  // Re-Measure nach Font-Load

    const tick = () => {
      const dir = vel < -.5 ? 1 : -1;
      x += dir * (0.9 + Math.min(Math.abs(vel) * .35, 7));
      vel *= .9;
      gsap.set(track, { x: wrap(x) });
    };
    new IntersectionObserver(([e]) => {
      e.isIntersecting ? gsap.ticker.add(tick) : gsap.ticker.remove(tick);
    }).observe(track.parentElement);
  })();

  /* ---------- Reveals: DEEP-LINK-SICHER (IntersectionObserver + Init-Sweep + Failsafe) ----------
     Ersetzt die alte ScrollTrigger.batch(once:true)-Logik, deren onEnter für Elemente OBERHALB
     des Viewports beim Laden nie feuerte → ganze Sektionen blieben bei #anchor-Deep-Links leer.  */
  (function reveals() {
    if (prefersReduced) {
      gsap.set('.reveal', { opacity: 1, y: 0 });
      gsap.set('.reveal-img', { clipPath: 'none' });
      gsap.set('.lead-inner', { yPercent: 0 });
      return;
    }
    const vh = () => window.innerHeight;
    const showEl = (el, d = 0) => { el.classList.add('is-revealed'); gsap.to(el, { opacity: 1, y: 0, duration: 1.1, ease: EASE, delay: d, overwrite: 'auto' }); };
    const setEl  = (el) => { el.classList.add('is-revealed'); gsap.set(el, { opacity: 1, y: 0 }); };
    const showImg = (el) => { el.classList.add('is-revealed'); gsap.to(el, { clipPath: 'inset(0 0 0% 0)', duration: 1.4, ease: 'expo.inOut', overwrite: 'auto' }); };
    const setImg  = (el) => { el.classList.add('is-revealed'); gsap.set(el, { clipPath: 'inset(0 0 0% 0)' }); };

    // Gruppen-Stagger für gleichzeitig einfliegende .reveal
    let q = [], t = null;
    const flush = () => { q.forEach((el, i) => showEl(el, Math.min(i, 6) * 0.09)); q = []; t = null; };
    const queue = (el) => { if (el.classList.contains('is-revealed')) return; q.push(el); clearTimeout(t); t = setTimeout(flush, 45); };

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); queue(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });
    const ioImg = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { ioImg.unobserve(e.target); showImg(e.target); } });
    }, { rootMargin: '0px 0px -16% 0px', threshold: 0.01 });

    // Init-Sweep: oberhalb = sofort (Blindspot), im Viewport = animiert, darunter = beobachten
    const sweep = () => {
      document.querySelectorAll('.reveal:not(.is-revealed)').forEach((el) => {
        const top = el.getBoundingClientRect().top;
        if (top < 0) setEl(el);
        else if (top < vh() * 0.94) queue(el);
        else io.observe(el);
      });
      document.querySelectorAll('.reveal-img:not(.is-revealed)').forEach((el) => {
        const top = el.getBoundingClientRect().top;
        if (top < 0) setImg(el);
        else if (top < vh() * 0.9) showImg(el);
        else ioImg.observe(el);
      });
    };
    sweep();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sweep); // Layout-Shift nach Font-Load
    window.addEventListener('load', sweep, { once: true });
    setTimeout(sweep, 250); setTimeout(sweep, 800); // Anchor-/Deep-Link-Scroll settlen lassen

    // Versprechen-Zeilen: zusammen, sobald .manifest sichtbar
    const man = document.querySelector('.manifest');
    if (man) {
      const revealLead = () => gsap.to('.lead-inner', { yPercent: 0, duration: 1.2, ease: EASE, stagger: .12, overwrite: 'auto' });
      if (man.getBoundingClientRect().top < vh() * 0.9) revealLead();
      else {
        const ioLead = new IntersectionObserver((entries) => {
          entries.forEach((e) => { if (e.isIntersecting) { ioLead.disconnect(); revealLead(); } });
        }, { rootMargin: '0px 0px -18% 0px', threshold: 0.01 });
        ioLead.observe(man);
      }
    }

    // Hard-Failsafe: was im/über dem Viewport liegt, darf nach 4.5s NIE unsichtbar hängen
    setTimeout(() => {
      document.querySelectorAll('.reveal:not(.is-revealed)').forEach((el) => { if (el.getBoundingClientRect().top < vh()) setEl(el); });
      document.querySelectorAll('.reveal-img:not(.is-revealed)').forEach((el) => { if (el.getBoundingClientRect().top < vh()) setImg(el); });
      if (man && man.getBoundingClientRect().top < vh()) gsap.set('.lead-inner', { yPercent: 0 });
    }, 4500);

    // Scroll-Failsafe (Tills Review 31.07): Bei Anker-Loads (/#kaufen) blieb der
    // IntersectionObserver stumm → Sektionen darunter blieben ohne Bilder.
    // Jeder Scroll-Tick revealt deshalb zusätzlich alles, was im Viewport steht —
    // die Selektoren treffen nur Nicht-Reveltes und laufen sich damit leer.
    let rafPending = false;
    const scrollSweep = () => {
      rafPending = false;
      document.querySelectorAll('.reveal:not(.is-revealed)').forEach((el) => { if (el.getBoundingClientRect().top < vh() * 0.95) queue(el); });
      document.querySelectorAll('.reveal-img:not(.is-revealed)').forEach((el) => { if (el.getBoundingClientRect().top < vh() * 0.92) showImg(el); });
    };
    window.addEventListener('scroll', () => {
      if (!rafPending) { rafPending = true; requestAnimationFrame(scrollSweep); }
    }, { passive: true });
  })();

  /* ---------- Produktbühne: gerichtete Wipes + Counter-Roll ---------- */
  (function stage() {
    const imgs = gsap.utils.toArray('.stage-img');
    const beats = gsap.utils.toArray('.stage-copy .beat');
    const num = document.getElementById('stage-num');
    if (!imgs.length) return;
    let last = 0;

    gsap.set(imgs[0], { opacity: 1 });

    function activate(i) {
      if (i === last && num.textContent !== '01') return;
      const down = i >= last;
      last = i;
      imgs.forEach((img, j) => {
        img.setAttribute('aria-hidden', String(j !== i));
        if (j === i) {
          gsap.fromTo(img,
            { opacity: 1, clipPath: down ? 'inset(100% 0 0 0)' : 'inset(0 0 100% 0)', scale: 1.02 },
            { clipPath: 'inset(0% 0 0% 0)', scale: 1, duration: prefersReduced ? 0 : .9, ease: 'expo.inOut', overwrite: true });
        } else {
          gsap.to(img, { opacity: 0, duration: prefersReduced ? 0 : .5, delay: prefersReduced ? 0 : .25, ease: 'none', overwrite: true });
        }
      });
      num.textContent = String(i + 1).padStart(2, '0');
      if (!prefersReduced) {
        gsap.fromTo(num, { yPercent: down ? 70 : -70, opacity: 0 }, { yPercent: 0, opacity: 1, duration: .45, ease: EASE });
      }
    }

    beats.forEach((beat, i) => {
      ScrollTrigger.create({
        trigger: beat, start: 'top 62%', end: 'bottom 38%',
        onEnter: () => activate(i),
        onEnterBack: () => activate(i),
      });
    });

    /* Auto-Rotation + Klick: die drei Bilder wechseln von selbst alle 5 s,
       Klick aufs Bild springt sofort weiter (Scroll-Beats greifen weiterhin). */
    let stageTimer;
    const dots = gsap.utils.toArray('.stage-dot');
    const origActivate = activate;
    activate = function (i) {
      origActivate(i);
      dots.forEach((d, j) => d.classList.toggle('is-on', j === i));
    };
    dots.forEach((d) => d.addEventListener('click', (e) => {
      e.stopPropagation();
      activate(parseInt(d.dataset.i, 10));
      clearInterval(stageTimer);
      stageTimer = setInterval(() => activate((last + 1) % imgs.length), 5000);
    }));
    /* Pfeile links/rechts: explizite Prev/Next-Navigation (Tills Review 31.07) */
    gsap.utils.toArray('.stage-arrow').forEach((btn) => btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const dir = parseInt(btn.dataset.dir, 10) || 1;
      activate((last + dir + imgs.length) % imgs.length);
      clearInterval(stageTimer);
      stageTimer = setInterval(() => activate((last + 1) % imgs.length), 5000);
    }));
    stageTimer = setInterval(() => activate((last + 1) % imgs.length), 4000);
    const stageEl = document.getElementById('stage-sticky');
    if (stageEl) stageEl.addEventListener('click', () => {
      activate((last + 1) % imgs.length);
      clearInterval(stageTimer);
      stageTimer = setInterval(() => activate((last + 1) % imgs.length), 5000);
    });

    /* Wischgeste auf der Bühne: horizontal > 40px → vor/zurück */
    if (stageEl) {
      let sx = 0, sy = 0, tracking = false;
      stageEl.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
      }, { passive: true });
      stageEl.addEventListener('touchend', (e) => {
        if (!tracking) return; tracking = false;
        const dx = e.changedTouches[0].clientX - sx;
        const dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        const next = dx < 0 ? (last + 1) % imgs.length : (last - 1 + imgs.length) % imgs.length;
        activate(next);
        clearInterval(stageTimer);
        stageTimer = setInterval(() => activate((last + 1) % imgs.length), 5000);
      }, { passive: true });
    }

    if (!prefersReduced) {
      beats.forEach((beat) => {
        gsap.fromTo(beat, { opacity: .45 }, {
          opacity: 1, duration: .6, ease: 'none',
          scrollTrigger: { trigger: beat, start: 'top 75%', end: 'top 45%', scrub: true },
        });
      });
    }
  })();

  /* ---------- 3D-Tilt + Magnetic Buttons (nur Desktop-Pointer) ---------- */
  if (pointerFine && !prefersReduced) {
    document.querySelectorAll('.product-card, .mono-card, .elle-card').forEach((card) => {
      const rx = gsap.quickTo(card, 'rotationX', { duration: .5, ease: EASE });
      const ry = gsap.quickTo(card, 'rotationY', { duration: .5, ease: EASE });
      const y = gsap.quickTo(card, 'y', { duration: .5, ease: EASE });
      gsap.set(card, { transformPerspective: 900 });
      card.addEventListener('pointermove', (e) => {
        const r = card.getBoundingClientRect();
        rx(gsap.utils.clamp(-5, 5, -((e.clientY - r.top) / r.height - .5) * 10));
        ry(gsap.utils.clamp(-5, 5, ((e.clientX - r.left) / r.width - .5) * 10));
      });
      card.addEventListener('pointerenter', () => y(-6));
      card.addEventListener('pointerleave', () => { rx(0); ry(0); y(0); });
    });
    document.querySelectorAll('.btn-gold').forEach((btn) => {
      const bx = gsap.quickTo(btn, 'x', { duration: .45, ease: EASE });
      const by = gsap.quickTo(btn, 'y', { duration: .45, ease: EASE });
      btn.addEventListener('pointermove', (e) => {
        const r = btn.getBoundingClientRect();
        bx(gsap.utils.clamp(-4, 4, (e.clientX - r.left - r.width / 2) * .12));
        by(gsap.utils.clamp(-4, 4, (e.clientY - r.top - r.height / 2) * .16));
      });
      btn.addEventListener('pointerleave', () => { bx(0); by(0); });
    });
  }

  /* ---------- Kollektion: ganze Kachel klickbar (2D-Tilt bleibt) ----------
     Klick auf die leere Fläche der Karte führt zum Produkt. Eigenständige
     Elemente (Thumbs, Lightbox-Buttons, „ändern"-Link, CTAs) bleiben unberührt. */
  (function cardNav() {
    document.querySelectorAll('.product-card').forEach((card) => {
      const link = card.querySelector('a.product-media[href], .product-name a[href]');
      if (!link) return;
      const href = link.getAttribute('href');
      card.classList.add('is-clickable');
      card.addEventListener('click', (e) => {
        if (e.target.closest('a, button, input, label, [data-lb]')) return; // eigene Handler haben Vorrang
        if (window.getSelection && String(window.getSelection())) return;    // Textauswahl nicht abbrechen
        window.location.href = href;
      });
    });
  })();

  /* ---------- Produktbild-Sets (für Lightbox) ---------- */
  const ASSET_BASE = (document.body && document.body.dataset.assetBase) || '';
  const GALLERIES = {
    nocturne: [
      { src: ASSET_BASE + 'cardholder-monogramm.webp', alt: 'Cardholder Nocturne, Monogramm-Seite mit goldener Gravur L.M' },
      { src: ASSET_BASE + 'cardholder-vorderseite.webp', alt: 'Cardholder Nocturne, Schlitzseite' },
      { src: ASSET_BASE + 'lifestyle-ocean-1.webp', alt: 'Cardholder Nocturne in der Hand über dem Meer' },
      { src: ASSET_BASE + 'lifestyle-ocean-2.webp', alt: 'Cardholder Nocturne über schäumender Gischt' },
    ],
    trinite: [
      { src: ASSET_BASE + 'bracelet-navy.webp', alt: 'Bracelet Trinité — Marineblau mit goldenem Trinity-Ring' },
      { src: ASSET_BASE + 'bracelet-rose.webp', alt: 'Bracelet Trinité — Rosé mit goldenem Trinity-Ring' },
      { src: ASSET_BASE + 'bracelet-black.webp', alt: 'Bracelet Trinité — Schwarz mit goldenem Trinity-Ring' },
      { src: ASSET_BASE + 'bracelet-weiss.webp', alt: 'Bracelet Trinité — Weiß mit goldenem Trinity-Ring' },
    ],
    eclat: [
      { src: ASSET_BASE + 'eclat-gold-navy.webp', alt: 'Bracelet Éclat in Gold — Zirkonia im Brillantschliff' },
      { src: ASSET_BASE + 'eclat-gold-lifestyle.webp', alt: 'Bracelet Éclat in Gold am Handgelenk' },
      { src: ASSET_BASE + 'eclat-rose-navy.webp', alt: 'Bracelet Éclat in Rosé' },
      { src: ASSET_BASE + 'eclat-silber-lifestyle.webp', alt: 'Bracelet Éclat in Silber am Handgelenk' },
      { src: ASSET_BASE + 'eclat-gold-detail.webp', alt: 'Bracelet Éclat — die Fassung im Detail' },
    ],
  };

  /* ---------- Lightbox ---------- */
  let openLightbox = () => {};
  (function lightbox() {
    const lb = document.getElementById('lightbox');
    if (!lb) return;
    const img = document.getElementById('lb-img');
    const curEl = document.getElementById('lb-cur');
    const totEl = document.getElementById('lb-total');
    const closeBtn = document.getElementById('lb-close');
    let list = [], idx = 0, lastFocus = null;
    const isOpen = () => lb.classList.contains('is-open');

    function render() {
      const it = list[idx]; if (!it) return;
      img.src = it.src; img.alt = it.alt || '';
      curEl.textContent = idx + 1; totEl.textContent = list.length;
      if (!prefersReduced) gsap.fromTo(img, { opacity: 0, scale: .985 }, { opacity: 1, scale: 1, duration: .4, ease: EASE, overwrite: true });
    }
    function go(d) { if (!list.length) return; idx = (idx + d + list.length) % list.length; render(); }
    function open(key, start) {
      list = GALLERIES[key] || []; if (!list.length) return;
      idx = Math.min(Math.max(start | 0, 0), list.length - 1);
      lastFocus = document.activeElement;
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      lb.classList.add('is-open');
      render(); closeBtn.focus();
    }
    function close() {
      lb.classList.remove('is-open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openLightbox = open;

    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-lb]');
      if (!t) return;
      e.preventDefault();
      open(t.dataset.lb, parseInt(t.dataset.lbIndex || '0', 10));
    });
    closeBtn.addEventListener('click', close);
    document.getElementById('lb-prev').addEventListener('click', () => go(-1));
    document.getElementById('lb-next').addEventListener('click', () => go(1));
    lb.addEventListener('click', (e) => { if (e.target === lb || e.target.tagName === 'FIGURE') close(); });
    document.addEventListener('keydown', (e) => {
      if (!isOpen()) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
      else if (e.key === 'Tab') {
        const f = gsap.utils.toArray(lb.querySelectorAll('button'));
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      }
    });
    let sx = 0;
    lb.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', (e) => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 45) go(dx < 0 ? 1 : -1); }, { passive: true });
  })();

  
  /* ---------- Monogramm: Prägestempel + Sheen + CTA ---------- */
  (function monogram() {
    const input = document.getElementById('initials-input');
    const preview = document.getElementById('initials-preview');
    const cta = document.getElementById('mono-cta');
    const cartInitials = document.getElementById('cart-initials');
    let lastLen = 0;

    function render(letters) {
      const joined = letters ? letters.split('').join('.') : 'L.M';
      preview.innerHTML = joined.split('').map((c) => `<span class="mi">${c}</span>`).join('');
      const monoPrice = cta.dataset.price || '44,90 €';   // Preis der Monogramm-Variante aus Liquid
      cta.textContent = letters ? `Mit ${joined} prägen — ${monoPrice}` : `Mit deinen Initialen prägen — ${monoPrice}`;
      cartInitials.textContent = joined;
    }

    input.addEventListener('input', () => {
      const letters = input.value.toUpperCase().replace(/[^A-ZÄÖÜ]/g, '').slice(0, 3);
      input.value = letters;
      const grew = letters.length > lastLen;
      lastLen = letters.length;
      render(letters);
      if (prefersReduced || !letters) return;
      if (grew) {
        const mis = preview.querySelectorAll('.mi');
        gsap.fromTo(mis[mis.length - 1], { yPercent: -55, scale: 1.5, opacity: 0 },
          { yPercent: 0, scale: 1, opacity: 1, duration: .45, ease: EASE });
        gsap.fromTo('.mono-card', { scale: 1.006 }, { scale: 1, duration: .4, ease: EASE });
        gsap.fromTo('.mono-sheen', { xPercent: -120 }, { xPercent: 120, duration: .9, ease: 'power2.out', overwrite: true });
      }
    });
  })();

  /* ---------- Commerce: Duo-Optionen + Warenkorb + Buybar ---------- */
  (function commerce() {
    const price = null;
    const radios = [];
    radios.forEach((r) => r.addEventListener('change', () => {
      price.innerHTML = `${r.value}<span class="cur"> €</span>`;
    }));

    document.querySelectorAll('.js-set').forEach((a) => a.addEventListener('click', () => {
      const set = document.getElementById('opt-set');
      set.checked = true;
      set.dispatchEvent(new Event('change'));
    }));

    const form = document.getElementById('cercle-form');
    document.querySelectorAll('.js-cart').forEach((btn) => {
      const original = btn.textContent;
      btn.addEventListener('click', () => {
        btn.textContent = 'Der Shop öffnet in Kürze';
        setTimeout(() => { btn.textContent = original; }, 2600);
        form.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'center' });
        setTimeout(() => form.querySelector('input').focus({ preventScroll: true }), prefersReduced ? 0 : 700);
      });
    });

    const buybar = document.getElementById('buybar');
    if (!buybar) return;
    buybar.inert = true;
    /* Kaufen liegt jetzt direkt unter dem Hero: Leiste erscheint erst, wenn die
       Produkte aus dem Blick gescrollt sind (Rückweg zum Kauf), und verschwindet am Footer */
    ScrollTrigger.create({
      trigger: '#kaufen', start: 'bottom 70%', endTrigger: '.footer', end: 'top 85%',
      onToggle: (self) => {
        buybar.classList.toggle('is-on', self.isActive);
        buybar.setAttribute('aria-hidden', String(!self.isActive));
        buybar.inert = !self.isActive;
      },
    });
  })();

  /* ---------- Cercle-Formular ---------- */
  (function cercle() {
    const form = document.getElementById('cercle-form');
    if (!form) return;
    const status = document.getElementById('cercle-status');
    const input = form.querySelector('input[type="email"]');
    if (!input) return;
    form.addEventListener('submit', (e) => {
      if (input.validity.valid && input.value.trim()) {
        form.classList.remove('is-error');
        status.classList.remove('is-error');
        /* nativ submitten — Shopify legt den Kontakt an und lädt mit Bestätigung neu */
      } else {
        e.preventDefault();
        form.classList.add('is-error');
        status.classList.add('is-error');
        status.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.';
      }
    });
  })();

  /* ---------- Layout-Stabilität ---------- */
  window.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => ScrollTrigger.refresh());

  /* ---------- Reduced-Motion-Wechsel zur Laufzeit ---------- */
  reducedMq.addEventListener('change', (e) => {
    prefersReduced = staticMode || e.matches;
    if (prefersReduced) {
      if (video) video.pause();
      gsap.globalTimeline.clear();
      killPreloader();
    }
  });
}
